import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MineralFertilizerType, OrganicFertilizerType } from '~/api/services/climaCheck'
import Dialog from '~/components/Dialog'
import CustomInput from '~/components/CustomInput'
import FertilizerSlider from './FertilizerSlider'
import { Grid } from 'semantic-ui-react'

interface Props {
  handleClose: () => void
  fertilizerData: OrganicFertilizerType | MineralFertilizerType
  handleSubmit: (fertilizerData: OrganicFertilizerType | MineralFertilizerType, updateData) => void
}

const defaultValues = {
  n: '',
  nUsable: '',
  p2o5: '',
  p2o5Usable: '',
  k2o: '',
  k2oUsable: ''
}

export const fertilizerDataFields = [
  {
    name: 'N',
    key: 'n',
    unit: 'kg/t bzw. kg/m³'
  },
  {
    name: '<span>P<sub>2</sub>O<sub>5</sub><span>',
    key: 'p2o5',
    unit: 'kg/t bzw. kg/m³'
  },
  {
    name: '<span>K<sub>2</sub>O</span>',
    key: 'k2o',
    unit: 'kg/t bzw. kg/m³'
  }
]

const EditFertilizers: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { handleClose, fertilizerData, handleSubmit } = props

  const [fertilizerValues, setFertlizerValues] = useState(defaultValues)

  useEffect(() => {
    if (fertilizerData) {
      //@ts-ignore
      setFertlizerValues(fertilizerData)
    }
  }, [fertilizerData])

  function handleSubmitFertilizer() {
    setFertlizerValues(defaultValues)
    handleSubmit(fertilizerData, fertilizerValues)
  }

  function renderFertilizerValues() {
    return <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1rem', minWidth: 550 }}>
      {fertilizerDataFields.map(fertilizerField => {
        const usageValue = fertilizerValues[`${fertilizerField.key}Usable`]
        return <Grid columns={2} key={fertilizerData?.id}>
          <Grid.Row style={{ alignItems: 'end' }}>
            <Grid.Column>
              <CustomInput
                key={fertilizerField.key}
                value={fertilizerValues[fertilizerField.key]}
                label={<div dangerouslySetInnerHTML={{ __html: `<div style="display:flex; gap:5px; flex-direction: row;">${fertilizerField.name} <span>(${usageValue}%)</span></div>` }} />}
                decimalScale={2}
                withLabels
                inputWidth={'100%'}
                suffix={` ${fertilizerField.unit}`}
                allowDecimals={true}
                placeholder={`in ${fertilizerField.unit}`}
                onChange={(value) => setFertlizerValues({ ...fertilizerValues, [fertilizerField.key]: value || '' })}
              />
            </Grid.Column>
            <Grid.Column>
              <FertilizerSlider
                value={usageValue}
                onChange={(value) => setFertlizerValues({ ...fertilizerValues, [`${fertilizerField.key}Usable`]: value || '' })}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      })}
    </div>
  }

  return <Dialog
    textHeader={fertilizerData?.label}
    textClose={t('Cancel')}
    type='abort'
    style={{ width: 650 }}
    textSubmit={t('Adjust')}
    isDialogOpen={Boolean(fertilizerData)}
    handleClose={() => {
      setFertlizerValues(defaultValues)
      handleClose()
    }}
    handleSubmit={() => handleSubmitFertilizer()}
    textContent={renderFertilizerValues()}
  />
}
export default EditFertilizers